import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { ErrorHandlingService } from 'src/app/features/ada-access/shared/errorHandling/errorHandling.service';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class KeycloakStateService {
  private sessionId: string;
  private userId: string;
  private transactionId: string;
  private realmRoles$ = new BehaviorSubject<string[]>([]);
  private organizationId$ = new BehaviorSubject<string | null>(null);



  private readonly ruleUrl = environment.apiUrl;


  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService,
    private keycloakService: KeycloakService
  ) { }

  setSessionId(sessionId: string): void {
    this.sessionId = sessionId;
  }

  getSessionId(): string {
    return this.sessionId;
  }

  setUserId(userId: string): void {
    this.userId = userId;
  }
  // setters
  setRealmRoles(realmRoles: string[]): void {
    console.log('Setting roles in service:', realmRoles);
    this.realmRoles$.next(realmRoles.map(r => r.toLowerCase()));
  }
  setOrganizationId(orgId: string): void {
    this.organizationId$.next(orgId);
  }

  // getters
  getRealmRoles(): string[] {
    return this.realmRoles$.getValue();
  }
  getOrganizationId(): string | null {
    return this.organizationId$.getValue();
  }

  // observables for subscribers
  observeRealmRoles(): Observable<string[]> {
    return this.realmRoles$.asObservable();
  }
  observeOrganizationId(): Observable<string | null> {
    return this.organizationId$.asObservable();
  }


  getUserId(): string {
    return this.userId;
  }

  getTransactionId(): string {
    return this.transactionId;
  }

  generateTransactionId(): Observable<string> {
    return this.http.post<string>(`${this.ruleUrl}/getTransactionId`, {})

      .pipe(
        map((response) => {
          this.transactionId = response; // Assign the response to transactionId
          return response; // Return the response as a string
        }),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

termsAndConditionsVerify(): Observable<any> {
  return this.http.post<any>(`${this.ruleUrl}/terms-and-conditions/verify`, {}).pipe(
    map(response => {
      console.log('Terms and Conditions response:', response);
      return response;
    }),
    catchError(error => this.errorHandlingService.handleError(error))
  );
}


  async loginOrLogout(isLoggedIn: boolean): Promise<void> {
    if (isLoggedIn) {
      await this.keycloakService.logout();
    } else {
      await this.keycloakService.login({
        redirectUri: environment.keyCloakRedirectUrl,
      });

      this.generateTransactionId().subscribe((response) => {
        console.log('Transaction Id:', response);
      });
    }
  }

   async sendTokenToBackend() {
    const token = await this.keycloakService.getToken(); // ⬅️ gets Keycloak token

    return this.http.post(`${environment.apiUrl}`+'/set-token', { token }).subscribe({
      next: () => console.log('Token sent to backend successfully ✅'),
      error: (err) => console.error('Failed to send token ', err)
    });
  }


}
